import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    height: '100%'
  },
  paper: {
    position: 'absolute',
    top: 75, left: 10, right: 10, bottom: 10,
    textAlign: 'center',
    padding: theme.spacing.unit
  }
})

class Error extends React.Component {

  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, info: null }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
  }

  render() {
    const { children, classes } = this.props
    const { hasError } = this.state
    return hasError ?
      <div className={classes.root}>
        <Paper className={classes.paper} elevation={1}>
          <Paper className={classes.paper} elevation={0} style={{ width: '50%', margin: '0 auto' }}>
            <Typography variant='headline' color='error' style={{margin: 10}}>
              An unexpected error has occurred<br/><br/>
            </Typography>
            <Typography component='h1'>
              <b>Please check the following before contacting support:</b><br/><br/>
            </Typography>
            <Typography component='p' style={{margin: 10, textAlign: 'left'}}>
              <b>1) Is your browser supported?</b><br/>
              Addresscloud Batch uses modern technology and requires a modern browser,
              Google Chrome is recommended for the best user experience.  Recent versions of
              Microsoft Edge, Firefox and Safari should also work well.  Internet Explorer
              is not officially supported however IE11 users should be able to use
              the application but not all features will be available.<br/><br/>
              <b>2) Did you arrive here using a bookmark?</b><br/>  Please check your bookmarks to make sure
              you have bookmarked https://maps.addresscloud.com<br/> and not https://login.addresscloud.com/xxxx.
            </Typography>
            <Typography component='p' style={{margin: 20}}>
              If the issue persists, please contact <a href='mailto:support@addresscloud.com'>support@addresscloud.com</a>
            </Typography>
          </Paper>
        </Paper>
      </div>
      :
      children
  }
}

Error.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Error)
